import type { TaskPriorityUnionType } from '@api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Group, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { getTaskPriorityPresentation } from '../../../../utils';

type TaskPriorityBadgePropsType = {
  priority: TaskPriorityUnionType;
};

export const TaskPriorityBadge: React.FC<TaskPriorityBadgePropsType> = ({
  priority,
}) => {
  const { t } = useTranslation('tasks');
  const presentation = getTaskPriorityPresentation(priority);
  const label = t(`PRIORITY.${priority}`);

  return (
    <Group gap={6} wrap="nowrap" aria-label={label}>
      <FontAwesomeIcon
        icon={presentation.icon}
        size="xs"
        color={presentation.color}
      />
      <Text size="sm" c="dimmed">
        {label}
      </Text>
    </Group>
  );
};
